import styled from "styled-components"
import { FlexWrapper } from "components/ui/FlexWrapper/styles"

export const Wrapper = styled.div`
  ${({ theme }) =>
    `background: linear-gradient(0deg, ${theme.colors.basic} 0%, ${theme.colors.basic2} 100%);`};
  width: 100%;
  max-width: 100vw;
  margin-bottom: 4rem;

  ${({ theme }) => theme.breakpoints.tablet} {
    border-radius: 24px;
    margin-bottom: 4rem;
  }

  ${({ theme }) => theme.breakpoints.smallDesktop} {
    max-width: 1440px;
    margin-bottom: 4rem;
  }
`
export const ContentWrapper = styled(FlexWrapper)`
  ${({ theme }) => theme.breakpoints.smallDesktop} {
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
  }
`

export const Box = styled.div`
  &:first-child {
    margin: 4rem 2rem 2rem;

    ${({ theme }) => theme.breakpoints.smallDesktop} {
      margin: 8rem 0 8rem 76px;
      flex-basis: 50%;
    }

    ${({ theme }) => theme.breakpoints.largeDesktop} {
      flex-basis: 40%;
    }
  }

  &:nth-child(2) {
    margin-bottom: 4rem;
    width: 100%;

    ${({ theme }) => theme.breakpoints.tablet} {
      margin: 0 auto 4rem;
    }

    ${({ theme }) => theme.breakpoints.smallDesktop} {
      margin: 0 76px 0 3%;
      width: 50%;
    }
  }
`
